import * as React from 'react'

import { ArrowRightIcon } from 'lucide-react'
import { observer } from 'mobx-react'

import { SitePermitStatus, WorkflowStepType } from '~/client/graph'
import StatusBadge from '~/client/src/shared/components/StatusBadge/StatusBadge'
import {
  formStatusByWorkflowActionMap,
  workflowActionsByStepsMap,
  WorkflowStepAction,
} from '~/client/src/shared/enums/WorkflowStepAction'
import { getWorkflowActionDisplayName } from '~/client/src/shared/localization/enumDisplayTexts'

// localization: no text to translate

interface IProps {
  stepType: WorkflowStepType
  workflowStepLevel: number
  isLastStep?: boolean
}

const ignoredActions = [
  WorkflowStepAction.CHANGE,
  WorkflowStepAction.DENY,
  WorkflowStepAction.FAIL,
]
const getStatusByAction = (
  action: WorkflowStepAction,
  isLastStep: boolean,
): SitePermitStatus =>
  isLastStep && !ignoredActions.includes(action)
    ? SitePermitStatus.Done
    : formStatusByWorkflowActionMap[action]

@observer
export default class WorkflowStepActions extends React.Component<IProps> {
  public render() {
    const { stepType, workflowStepLevel, isLastStep } = this.props
    const actions = workflowActionsByStepsMap[stepType]

    return (
      <div className="col pt5">
        {actions.map(action => {
          const status = getStatusByAction(action, isLastStep)
          const isStepLevelShown =
            !isLastStep && !ignoredActions.includes(action)

          return (
            <div key={action} className="row mb5 wrap">
              <div className="ba-light-grey brada10 h20 px10 no-grow nowrap">
                {getWorkflowActionDisplayName(action)}
              </div>
              {!!status && (
                <>
                  <ArrowRightIcon
                    size={16}
                    className="tw:mx-1 tw:text-muted-foreground"
                  />
                  <StatusBadge
                    className="no-grow"
                    status={status}
                    workflowStepLevel={isStepLevelShown && workflowStepLevel}
                    isLate={false}
                  />
                </>
              )}
            </div>
          )
        })}
      </div>
    )
  }
}
